export const termsConditions =
`<div id="pre_terms_container">
    <div id="terms_container">
      <iframe id="embed" src="https://dook.sa/clientTerms/"></iframe>
    </div>
  </div>`;



// WEBPACK FOOTER //
// ./src/constants/termsConditions.js